/**
 * Bundle Logo Uploader v1.0.0
 * Standalone component for bundle product logo upload + text customization.
 * No PitchPrint dependency.
 */
(function() {
  'use strict';

  var log = function() {
    if (window.PITCHPRINT_DEBUG) console.log.apply(console, ['[BundleLogo]'].concat(Array.from(arguments)));
  };

  // ==========================================
  // State
  // ==========================================
  var state = {
    logoToggleEnabled: false,
    textToggleEnabled: false,
    logoUrl: null,
    logoFileName: null,
    isUploading: false,
    textValue: ''
  };

  // ==========================================
  // DOM References
  // ==========================================
  var els = {};

  // ==========================================
  // Initialization
  // ==========================================
  function init() {
    var container = document.getElementById('bundle-logo-uploader');
    if (!container) return;

    log('Initializing bundle logo uploader');

    els.container = container;
    els.logoToggle = document.getElementById('bundle-toggle-logo');
    els.textToggle = document.getElementById('bundle-toggle-text');
    els.logoSection = document.getElementById('bundle-logo-section');
    els.textSection = document.getElementById('bundle-text-section');
    els.uploaderArea = document.getElementById('bundle-logo-uploader-area');
    els.fileInput = document.getElementById('bundle-logo-input');
    els.preview = document.getElementById('bundle-logo-preview');
    els.removeBtn = document.getElementById('bundle-logo-remove');
    els.errorEl = document.getElementById('bundle-logo-error');
    els.textInput = document.getElementById('bundle-text-input');
    els.charCount = container.querySelector('.text-customizer__char-count .current');
    els.logoUrlInput = document.getElementById('bundle-logo-url-input');
    els.textValueInput = document.getElementById('bundle-text-value-input');
    els.customizationInput = document.getElementById('bundle-customization-input');

    attachListeners();
    setupFormValidation();

    log('Initialized successfully');
  }

  function attachListeners() {
    // Toggle checkboxes
    if (els.logoToggle) {
      els.logoToggle.addEventListener('change', handleLogoToggle);
    }
    if (els.textToggle) {
      els.textToggle.addEventListener('change', handleTextToggle);
    }

    // Logo upload area
    if (els.uploaderArea) {
      els.uploaderArea.addEventListener('click', handleUploaderClick);
      els.uploaderArea.addEventListener('dragover', handleDragOver);
      els.uploaderArea.addEventListener('dragleave', handleDragLeave);
      els.uploaderArea.addEventListener('drop', handleDrop);
    }

    // File input
    if (els.fileInput) {
      els.fileInput.addEventListener('change', handleFileSelect);
    }

    // Remove button
    if (els.removeBtn) {
      els.removeBtn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        removeLogo();
      });
    }

    // Text input
    if (els.textInput) {
      els.textInput.addEventListener('input', handleTextInput);
    }
  }

  // ==========================================
  // Toggle Logic
  // ==========================================
  function handleLogoToggle(e) {
    state.logoToggleEnabled = e.target.checked;
    log('Logo toggle:', state.logoToggleEnabled);

    if (state.logoToggleEnabled) {
      els.logoSection.classList.remove('is-hidden');
    } else {
      els.logoSection.classList.add('is-hidden');
      removeLogo();
    }
    clearValidation(els.uploaderArea);
    updateHiddenInputs();
  }

  function handleTextToggle(e) {
    state.textToggleEnabled = e.target.checked;
    log('Text toggle:', state.textToggleEnabled);

    if (state.textToggleEnabled) {
      els.textSection.classList.remove('is-hidden');
      // Focus the text input after transition
      setTimeout(function() { els.textInput && els.textInput.focus(); }, 350);
    } else {
      els.textSection.classList.add('is-hidden');
      state.textValue = '';
      if (els.textInput) els.textInput.value = '';
      if (els.charCount) els.charCount.textContent = '0';
    }
    clearValidation(els.textInput);
    updateHiddenInputs();
  }

  // ==========================================
  // Logo Upload
  // ==========================================
  function handleUploaderClick(e) {
    // Don't trigger file input if clicking the remove button
    if (e.target.closest('.logo-uploader__remove')) return;
    els.fileInput.click();
  }

  function handleDragOver(e) {
    e.preventDefault();
    els.uploaderArea.classList.add('is-dragover');
  }

  function handleDragLeave(e) {
    els.uploaderArea.classList.remove('is-dragover');
  }

  function handleDrop(e) {
    e.preventDefault();
    e.stopPropagation();
    els.uploaderArea.classList.remove('is-dragover');
    if (e.dataTransfer.files && e.dataTransfer.files[0]) {
      processFile(e.dataTransfer.files[0]);
    }
  }

  function handleFileSelect(e) {
    if (this.files && this.files[0]) {
      processFile(this.files[0]);
    }
  }

  function processFile(file) {
    clearError();
    clearValidation(els.uploaderArea);

    // Validate type
    var validTypes = ['image/png', 'image/jpeg', 'image/jpg', 'image/svg+xml'];

    // Block SVG on mobile (can cause issues)
    if (file.type === 'image/svg+xml' && window.innerWidth < 768) {
      showError('SVG files are not supported on mobile devices. Please use PNG or JPG.');
      return;
    }

    if (validTypes.indexOf(file.type) === -1) {
      showError('Invalid file type. Please upload a PNG, JPG, or SVG file.');
      return;
    }

    // Validate size (10MB)
    if (file.size > 10 * 1024 * 1024) {
      showError('File too large. Maximum file size is 10MB.');
      return;
    }

    log('Processing file:', file.name, file.type, file.size);

    // Show preview
    var reader = new FileReader();
    reader.onload = function(e) {
      if (els.preview) {
        els.preview.src = e.target.result;
      }
      els.uploaderArea.classList.add('has-logo');
    };
    reader.readAsDataURL(file);

    state.logoFileName = file.name;

    // Upload to S3
    uploadToS3(file);
  }

  function uploadToS3(file) {
    state.isUploading = true;
    els.uploaderArea.classList.add('is-uploading');
    log('Starting S3 upload for:', file.name);

    var config = window.bundleLogoConfig || {};
    var apiEndpoint = config.uploadApiEndpoint || 'https://fz8y24ewil.execute-api.us-east-1.amazonaws.com/staging';

    getPresignedUrl(apiEndpoint, file)
      .then(function(presignResponse) {
        return putToS3(presignResponse.uploadUrl, file)
          .then(function() { return presignResponse; });
      })
      .then(function(presignResponse) {
        var cdnUrl = 'https://img.popsigns.co/' + presignResponse.originalKey;
        state.logoUrl = cdnUrl;
        state.isUploading = false;
        els.uploaderArea.classList.remove('is-uploading');
        updateHiddenInputs();
        log('Upload complete:', cdnUrl);
      })
      .catch(function(error) {
        console.error('[BundleLogo] Upload failed:', error);
        state.isUploading = false;
        els.uploaderArea.classList.remove('is-uploading');
        showError('Upload failed. Please try again.');
        removeLogo();
      });
  }

  function getPresignedUrl(apiEndpoint, file) {
    var customerId = getCustomerId();
    return fetch(apiEndpoint + '/api/uploads/presign', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shop-Domain': (window.Shopify && window.Shopify.shop) ? window.Shopify.shop : 'popsigns.co'
      },
      body: JSON.stringify({
        fileName: file.name,
        fileType: file.type,
        customerId: customerId,
        shape: 'bundle',
        side: 'logo'
      })
    }).then(function(res) {
      if (!res.ok) throw new Error('Presign failed: ' + res.status);
      return res.json();
    });
  }

  function putToS3(presignedUrl, file) {
    return new Promise(function(resolve, reject) {
      var xhr = new XMLHttpRequest();
      xhr.open('PUT', presignedUrl, true);
      xhr.setRequestHeader('Content-Type', file.type);
      xhr.onload = function() {
        if (xhr.status >= 200 && xhr.status < 300) {
          resolve();
        } else {
          reject(new Error('S3 upload failed: ' + xhr.statusText));
        }
      };
      xhr.onerror = function() { reject(new Error('Network error during upload')); };
      xhr.send(file);
    });
  }

  function getCustomerId() {
    var customerId = window.ShopifyAnalytics &&
                     window.ShopifyAnalytics.meta &&
                     window.ShopifyAnalytics.meta.page &&
                     window.ShopifyAnalytics.meta.page.customerId;
    return customerId ? String(customerId) : 'temp-' + Date.now();
  }

  function removeLogo() {
    state.logoUrl = null;
    state.logoFileName = null;
    state.isUploading = false;

    if (els.fileInput) els.fileInput.value = '';
    if (els.preview) els.preview.src = '';
    if (els.uploaderArea) {
      els.uploaderArea.classList.remove('has-logo', 'is-uploading', 'is-dragover');
    }

    clearError();
    updateHiddenInputs();
    log('Logo removed');
  }

  function showError(msg) {
    if (els.errorEl) {
      els.errorEl.textContent = msg;
      els.errorEl.style.display = 'block';
    }
  }

  function clearError() {
    if (els.errorEl) {
      els.errorEl.textContent = '';
      els.errorEl.style.display = 'none';
    }
  }

  // ==========================================
  // Text Input
  // ==========================================
  function handleTextInput(e) {
    state.textValue = e.target.value.trim();
    if (els.charCount) {
      els.charCount.textContent = e.target.value.length;
    }
    clearValidation(els.textInput);
    updateHiddenInputs();
  }

  // ==========================================
  // Form Integration
  // ==========================================
  function updateHiddenInputs() {
    // Logo URL
    if (els.logoUrlInput) {
      if (state.logoToggleEnabled && state.logoUrl) {
        els.logoUrlInput.value = state.logoUrl;
        els.logoUrlInput.disabled = false;
      } else {
        els.logoUrlInput.value = '';
        els.logoUrlInput.disabled = true;
      }
    }

    // Text value
    if (els.textValueInput) {
      if (state.textToggleEnabled && state.textValue) {
        els.textValueInput.value = state.textValue;
        els.textValueInput.disabled = false;
      } else {
        els.textValueInput.value = '';
        els.textValueInput.disabled = true;
      }
    }

    // Visible summary property
    if (els.customizationInput) {
      var hasLogo = state.logoToggleEnabled && state.logoUrl;
      var hasText = state.textToggleEnabled && state.textValue;

      if (hasLogo && hasText) {
        els.customizationInput.value = '✓ Logo + Text Added';
        els.customizationInput.disabled = false;
      } else if (hasLogo) {
        els.customizationInput.value = '✓ Logo Added';
        els.customizationInput.disabled = false;
      } else if (hasText) {
        els.customizationInput.value = '✓ Text Added';
        els.customizationInput.disabled = false;
      } else {
        els.customizationInput.value = '';
        els.customizationInput.disabled = true;
      }
    }
  }

  // ==========================================
  // Validation
  // ==========================================
  var productForm = null;

  function setupFormValidation() {
    // Find the product form via the hidden input's form attribute
    if (els.logoUrlInput && els.logoUrlInput.form) {
      productForm = els.logoUrlInput.form;
    } else {
      productForm = document.querySelector('form[data-type="add-to-cart-form"]');
    }

    if (productForm) {
      // IMPORTANT: attach in the CAPTURE phase on document, NOT a bubble-phase
      // listener on the form. The theme's <product-form> custom element registers
      // its own submit handler on this same form in its constructor (global.js),
      // which runs during element upgrade — i.e. BEFORE this script initializes.
      // Submit listeners on the same target fire in registration order, so a
      // bubble-phase listener here would run AFTER the theme has already AJAX-added
      // to cart, making preventDefault() useless. A capture-phase listener on an
      // ancestor (document) runs before the form's own listeners, letting us
      // stopImmediatePropagation() to block the theme handler when validation fails.
      document.addEventListener('submit', validateBeforeSubmit, true);
      log('Form validation attached (capture phase)');
    }
  }

  function validateBeforeSubmit(e) {
    // Only police submits coming from our own product form
    if (!productForm || e.target !== productForm) return;

    var valid = true;

    // Logo toggle ON but no logo uploaded
    if (state.logoToggleEnabled) {
      if (state.isUploading) {
        showValidation(els.uploaderArea, 'Please wait for the upload to finish');
        scrollToElement(els.uploaderArea);
        valid = false;
      } else if (!state.logoUrl) {
        showValidation(els.uploaderArea, 'Please upload your logo');
        scrollToElement(els.uploaderArea);
        valid = false;
      }
    }

    // Text toggle ON but no text entered
    if (state.textToggleEnabled && !state.textValue) {
      showValidation(els.textInput, 'Please enter your website or hashtag');
      scrollToElement(els.textInput);
      valid = false;
    }

    if (!valid) {
      // Stop the native submit AND prevent the theme's product-form handler
      // (and any other listeners) from running — otherwise the AJAX add fires.
      e.preventDefault();
      e.stopImmediatePropagation();
    } else {
      log('Validation passed');
    }
  }

  function showValidation(el, message) {
    if (!el) return;
    el.classList.add('validation-error', 'validation-pulse');

    // Remove existing message
    var existing = el.parentNode.querySelector('.validation-message');
    if (existing) existing.remove();

    // Add message
    var msg = document.createElement('div');
    msg.className = 'validation-message';
    msg.textContent = message;
    el.parentNode.appendChild(msg);

    // Remove pulse after animation
    setTimeout(function() { el.classList.remove('validation-pulse'); }, 1800);
  }

  function clearValidation(el) {
    if (!el) return;
    el.classList.remove('validation-error', 'validation-pulse');
    var msg = el.parentNode.querySelector('.validation-message');
    if (msg) msg.remove();
  }

  function scrollToElement(el) {
    if (!el) return;
    var rect = el.getBoundingClientRect();
    if (rect.top < 0 || rect.bottom > window.innerHeight) {
      el.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }

  // ==========================================
  // Boot
  // ==========================================
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
